import React from 'react'
import styled from 'styled-components'
import Modal from '~/prix/react/components/modal'
import { PulseLoader } from 'react-spinners'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 10px;
  width: 100%;
`

const Title = styled.h2`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
  margin: 0;
`

const Description = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.darkText};
  text-align: left;
  margin: 0;
  line-height: 1.5;
`

const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: end;
  width: 100%;
  margin-top: 10px;
`

const Button = styled.button`
  padding: 10px 20px;
  border-radius: ${({ theme }) => theme.borderRadius};
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.025);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`

const ConfirmButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;

  &:hover {
    opacity: 0.9;
  }
`

const CancelButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.lightGrey};
  color: ${({ theme }) => theme.colors.darkText};

  &:hover {
    background-color: ${({ theme }) => theme.colors.mediumGrey};
  }
`

interface ConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  title: string
  description?: string
}

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
}: ConfirmModalProps) {
  const [isLoading, setIsLoading] = React.useState(false)

  const handleConfirm = async () => {
    try {
      setIsLoading(true)
      await onConfirm()
      onClose()
    } catch (error) {
      console.error('Erro ao confirmar:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      baseWidth='400px'
      styles={{
        overlay: {
          zIndex: 10,
        },
      }}
    >
      <ModalContent>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
        <ButtonsContainer>
          <CancelButton onClick={onClose} disabled={isLoading}>
            Cancelar
          </CancelButton>
          <ConfirmButton onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? <PulseLoader color='white' size={8} /> : 'Confirmar'}
          </ConfirmButton>
        </ButtonsContainer>
      </ModalContent>
    </Modal>
  )
}
